import React, {
  Component, Fragment,
} from 'react';
import PropTypes from 'prop-types';
import { GroupLifeInsurance as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import TextareaInput from 'Components/Universal/Questionnaire/Fields/TextareaInput';
import { advisorView } from 'Context/ViewContext';
import { FaTooltipWrapper } from 'Components/UI/Tooltip';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import BoolInput from '../Fields/BoolInput';
import CurrencyInput from '../Fields/CurrencyInput';
import FieldList from '../Fields/FieldList';
import TextInput from '../Fields/TextInput';
import Section from '../Section';
import { getClientPicklistValue, shouldMakeNotesFieldReadOnly } from './Helpers/ClientPicklist';
import SelectInput from '../Fields/SelectInput';

class GroupLifeInsuranceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groupLifeInsuranceInsuredClientId: '',
    };

    this.onChange = this.onChange.bind(this);
    this.getPolicyName = this.getPolicyName.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  getPolicyName() {
    const { insuredClientOptions } = this.props;
    const { groupLifeInsuranceInsuredClientId } = this.state;
    return groupLifeInsuranceInsuredClientId ? getClientPicklistValue(insuredClientOptions, groupLifeInsuranceInsuredClientId) : 'New policy';
  }

  render() {
    const {
      getPolicyName,
      onChange,
      props: {
        id, insuredClientOptions, children: removeButton, expanded,
      },
      state: { groupLifeInsuranceInsuredClientId },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={getPolicyName()}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <SelectInput
          label="Insured"
          name={`groupLifeInsuranceInsuredClientId.${id}`}
          options={insuredClientOptions}
          answerKey="groupLifeInsuranceInsuredClientId"
          onChange={(name, value) => onChange('groupLifeInsuranceInsuredClientId', value)}
        />
        <TextInput
          placeholder="Insured Notes"
          name={`groupLifeInsuranceInsuredNotes.${id}`}
          answerKey="groupLifeInsuranceInsuredNotes"
          onChange={(name, value) => onChange('groupLifeInsuranceInsuredNotes', value)}
          readOnly={shouldMakeNotesFieldReadOnly(groupLifeInsuranceInsuredClientId)}
        />
        <TextInput
          placeholder="Insurance company"
          name={`groupLifeInsuranceCompany.${id}`}
          answerKey="groupLifeInsuranceCompany"
          onChange={(name, value) => onChange('groupLifeInsuranceCompany', value)
          }
        />
        <FaTooltipWrapper title="e.g. 30, 20, 15, 10">
          <TextInput
            placeholder="Length of coverage"
            name={`groupLifeInsuranceLength.${id}`}
            answerKey="groupLifeInsuranceLength"
          />
        </FaTooltipWrapper>
        <CurrencyInput
          placeholder="Coverage amount"
          name={`groupLifeInsuranceCoverage.${id}`}
          answerKey="groupLifeInsuranceCoverage"
        />
        <BoolInput
          label="Does this policy have a beneficiary?"
          name={`groupLifeInsuranceHasBeneficiary.${id}`}
          answerKey="groupLifeInsuranceHasBeneficiary"
          checkedChildren={
            <Fragment>
              <TextInput
                placeholder="Beneficiary (primary)"
                name={`groupLifeInsurancePrimaryBeneficiary.${id}`}
                answerKey="groupLifeInsurancePrimaryBeneficiary"
              />
              <TextInput
                placeholder="Beneficiary (contingent)"
                name={`groupLifeInsuranceContingentBeneficiary.${id}`}
                answerKey="groupLifeInsuranceContingentBeneficiary"
              />
            </Fragment>
          }
        />
        <TextareaInput
          requiredView={advisorView}
          placeholder="Notes"
          name={`groupLifeInsuranceNotes.${id}`}
          answerKey="groupLifeInsuranceNotes"
        />
      </LabeledVerticalExpander>
    );
  }
}

GroupLifeInsuranceList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  insuredClientOptions: PropTypes.array.isRequired,
};

GroupLifeInsuranceList.defaultProps = {
  expanded: false,
};

const GroupLifeInsurance = ({ insuredClientOptions }) => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
      transitionSpeed={0.25}
      height={400}
      title="Group Life Insurance"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
    >
      <FieldList
        onCountUpdate={setCount}
        label="Policy - group life"
        addLabel="Add a policy"
        keyPrefix="groupLifeInsurances"
        Of={GroupLifeInsuranceList}
        childProps={{ insuredClientOptions }}
      />
    </Section>
  );
};

GroupLifeInsurance.propTypes = {
  insuredClientOptions: PropTypes.array.isRequired,
};

export default GroupLifeInsurance;
